/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { invoice } from '@/api/ajax';
export const invoiceStatus = [
  {
    name: '未提交',
    key: 0
  },
  {
    name: '待开票',
    key: 1
  },
  {
    name: '待确认',
    key: 2
  },
  {
    name: '已驳回',
    key: 3
  },
  {
    name: '已开票',
    key: 4
  }
];
export default [
  {
    id: 'xsf',
    key: 'csoId',
    tip: '请输入销售方',
    required: false,
    slot: 'ajaxSelect',
    clearable: true,
    ajax: invoice.listSelectEnterprise,
    prop: {
      label: 'csoEnterpriseName',
      code: 'csoEnterpriseId'
    },
    ajaxQuery: 'csoEnterpriseName',
    width: 180
  },
  {
    width: 180,
    clearable: true,
    id: 'status',
    key: 'status',
    slot: 'select',
    tip: '请选择发票状态',
    options: invoiceStatus
  },
  {
    width: 180,
    clearable: true,
    id: 'monthrange',
    tip: '请选择完税月份',
    key: 'monthrange',
    slot: 'date',
    format: 'yyyy-MM',
    rangeValue: []
  }
];
